import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const NAV = [
  { label: "Home", href: "#home", testId: "footer-link-home" },
  { label: "Services", href: "#services", testId: "footer-link-services" },
  { label: "Data Security", href: "#data-security", testId: "footer-link-data-security" },
  { label: "Why Us", href: "#why-us", testId: "footer-link-why-us" },
];

export default function Footer() {
  return (
    <footer className="noise-overlay relative overflow-hidden bg-navy pt-20 pb-10" data-testid="site-footer">
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-12 border-b border-white/10 pb-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="inline-flex">
              <img
                src="/images/revanta-logo.png"
                alt="Revanta Asset Management — Recover, Reuse, Renew"
                className="h-24 w-auto"
                data-testid="footer-logo"
              />
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              Secure IT asset disposition and zero-landfill e-waste recycling for Australian
              businesses. Compliant, certified, and built for your ESG goals.
            </p>
            <p className="mt-6 flex items-center gap-2 text-sm text-slate-400" data-testid="footer-location">
              <MapPin className="h-4 w-4 text-eco" />
              Australia
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Explore</p>
            <ul className="flex flex-col gap-3">
              {NAV.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToId(link.href);
                    }}
                    data-testid={link.testId}
                    className="text-sm text-slate-300 transition-colors duration-300 hover:text-eco"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Contact</p>
            <ul className="flex flex-col gap-4">
              <li>
                <a
                  href="mailto:karan@revantaassetmanagement.com"
                  data-testid="footer-email-link"
                  className="flex items-center gap-3 text-sm text-slate-300 transition-colors duration-300 hover:text-eco"
                >
                  <Mail className="h-4 w-4 shrink-0 text-eco" />
                  karan@revantaassetmanagement.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+61466426343"
                  data-testid="footer-phone-link"
                  className="flex items-center gap-3 text-sm text-slate-300 transition-colors duration-300 hover:text-eco"
                >
                  <Phone className="h-4 w-4 shrink-0 text-eco" />
                  +61 466 426 343
                </a>
              </li>
            </ul>
            <button
              onClick={() => scrollToId("#book")}
              data-testid="footer-book-button"
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-eco/40 px-6 py-3 text-sm font-bold text-eco transition-[background-color,color] duration-300 hover:bg-eco hover:text-navy"
            >
              Book a Pickup
            </button>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-4 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            © {new Date().getFullYear()} Revanta Asset Management. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-xs text-slate-500 transition-colors hover:text-eco">
              Privacy Policy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-xs text-slate-500 transition-colors hover:text-eco">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>

    </footer>
  );
}
